import { KC_COLORS } from '../theme';

function scrollToCategoryTarget(targetId) {
  const el = document.getElementById(targetId);
  if (!el) return;

  const headerOffset = 112;
  const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;

  window.scrollTo({ top, behavior: 'smooth' });

  el.classList.remove('kc-category-target--flash');
  void el.offsetWidth;
  el.classList.add('kc-category-target--flash');
  window.setTimeout(() => {
    el.classList.remove('kc-category-target--flash');
  }, 1400);
}

export function CategorySidebar({ items = [] }) {
  if (!items.length) return null;

  return (
    <aside
      className="kc-category-sidebar h-fit rounded-2xl border bg-white px-5 pb-5 pt-4 md:px-6 md:pb-6 md:pt-5 text-left"
      style={{ borderColor: KC_COLORS.border }}
    >
      <div className="kc-category-sidebar-header mb-4 md:mb-5">
        <h2
          className="kc-type-h3 text-left m-0"
          style={{ color: KC_COLORS.primaryNavy }}
        >
          In This Category
        </h2>
      </div>

      <nav aria-label="In this category">
        <ul className="m-0 p-0 list-none space-y-1 text-left">
          {items.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className="kc-category-sidebar-link w-full text-left kc-type-body font-semibold"
                onClick={() => scrollToCategoryTarget(item.targetId)}
              >
                <span className="kc-category-sidebar-dot" aria-hidden="true" />
                <span className="kc-category-sidebar-text">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
